<template>
   <div class="dropdowigmp">
              <div class="atual" @click="abrirDropDow = !abrirDropDow">
                  <p>{{txt}}</p> <img src="../assets/seta.png" width="20px" alt="" :class="{virar:abrirDropDow}">
                </div>              
              <div :class="{opcoes:true,abrirDropDow}">
                  <div v-for="(n,i) in $store.state.opcoes" :key="i" @click="irParaPag(n.categoria,n.id)">
                      {{n.categoria}}
                  </div>
              </div>
          </div>
</template>

<script>
import cofing from '../services/config'

export default {
    data(){
        return{
            abrirDropDow:false,   
            txt:'Selecione o indicador que deseja calcular' 
        }
    },
    methods:{
        cookie(name){
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return null;
        },
       async irParaPag(c,id){
            this.$router.push({name:'categoria', params:{'categoria':id}})
            this.txt = c
            this.$store.state.id = id   
             this.$store.state.texto = this.txt       
            this.abrirDropDow = false
            console.log(this.$route)
            if(this.$route.name == 'categoria'){
                let result = await cofing.textos(id)             
                this.$emit('getTexto', result)
                this.$emit('deixarFalse', false)
            }
        }
    },
    async created(){
        let userCokie = this.cookie('usuario')
        if(userCokie == null){
            window.location = 'https://www.lefisc.com.br/'
        }else{
            let senha = this.cookie('senha')
            let re  = await cofing.buscarHash({"login":userCokie.toString(),"senha":senha.toString()})
            if(re.codigo == null || re.codigo == "" || re.codigo == undefined){
                window.location = 'https://www.lefisc.com.br/'
            }else{
                this.$store.state.hash  = re.codigo
            this.$store.state.opcoes = await cofing.categorias(this.$store.state.hash)
                if(this.$route.name == 'categoria'){
                this.$store.state.opcoes.map(e=>{
                        if(this.$route.params.categoria == e.id){
                            this.txt = e.categoria
                            this.$store.state.texto = this.txt
                            this.$store.state.id = e.id     
                        }
                
                })
            }
            }
        }
        
    }
}
</script>

<style lang="scss">
.dropdowigmp{
    height: 80px;
    width: 500px;
    border-radius: 5px;
    border-left: 5px solid #AF3437 !important;
    border:1px solid #707070;
    cursor: pointer;
    position: relative;
    margin-top:50px;
}
.dropdowigmp .atual img{
    transform: rotate(90deg);
    transition: 0.3s ease-in-out;
}
.dropdowigmp .atual img.virar{
    transform: rotate(270deg);
}
.dropdowigmp .atual{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding:20px;
}
.dropdowigmp .opcoes div{
    opacity: 0;
   width: 500px;
   padding: 5px;
    padding-left: 25px;
}
.dropdowigmp .opcoes div{   
    @for $i from 1 through 10{
        &:nth-child(#{$i}){
            animation-name: drop;
            animation-duration: 50ms ;    
            animation-delay: (50ms * $i) - 50;
            animation-fill-mode: forwards;
            animation-timing-function: ease-in-out;
        }
    }        
}
.dropdowigmp .opcoes div:hover{
    background: #f2f2f2;
}  
.dropdowigmp .opcoes div{
    height: 47px;
    border: 1px solid #707070;
    border-left: 5px solid #707070;
    background: #fff;
    display: flex;
    align-items: center;
    font-size: 15px;
}
@keyframes drop {
        0%{
            opacity: 0;
        }
        100%{
              opacity:  1;
        }
} 
.dropdowigmp .atual p{
    margin-bottom:0px;
     margin-top:0px;
     font-size: 18px;
     font-weight: 600;
}
.dropdowigmp .opcoes{
    position: absolute;
    top: 80px;
    display:none;
    right: 0px;
    z-index: 9;
}
.dropdowigmp div.abrirDropDow{display: initial;}          
</style>